/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CustomsOfficeTypes {
  None = 0,
  BorderSe = 1,
  BorderNo = 2,
  TransitDestination = 4,
  TransitDeparture = 8,
  Transit = 16,
}
